module.exports = __webpack_public_path__ + "static/Stage4Back-f4608af484859b4f3007a6b7bf582b1a.png";